/*
 * TEMPORÁRIO: remover este arquivo e sua inclusão no theme.liquid após o
 * período de migração dos visitantes que ainda possuem o contexto legado.
 */
(() => {
  const VALID_CONTEXTS = new Set(['PF', 'PJ']);
  const LEGACY_COOKIES = ['site_context', 'tipoRegister'];
  const LEGACY_STORAGE_KEYS = ['tipoRegister', 'toolbox_register_tipo', 'register_tipo'];

  function normalizeContext(value) {
    const context = String(value || '').trim().toUpperCase();
    return VALID_CONTEXTS.has(context) ? context : null;
  }

  function getCookie(name) {
    const prefix = `${name}=`;
    const cookie = document.cookie
      .split(';')
      .map((item) => item.trim())
      .find((item) => item.startsWith(prefix));
    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : '';
  }

  function getLegacyContext() {
    const cookieContext = normalizeContext(getCookie('site_context'));
    if (cookieContext) return cookieContext;

    const registrationCookie = normalizeContext(getCookie('tipoRegister'));
    if (registrationCookie) return registrationCookie;

    try {
      for (const key of LEGACY_STORAGE_KEYS) {
        const context = normalizeContext(window.localStorage.getItem(key));
        if (context) return context;
      }

      for (const key of LEGACY_STORAGE_KEYS) {
        const context = normalizeContext(window.sessionStorage.getItem(key));
        if (context) return context;
      }
    } catch (_error) {}

    return null;
  }

  function clearLegacyContext() {
    LEGACY_COOKIES.forEach((name) => {
      document.cookie = `${name}=; max-age=0; path=/; SameSite=Lax`;
    });

    try {
      LEGACY_STORAGE_KEYS.forEach((key) => {
        window.localStorage.removeItem(key);
        window.sessionStorage.removeItem(key);
      });
    } catch (_error) {}
  }

  async function migrate() {
    const body = document.body;
    if (!body) return;

    const resolvedContext = normalizeContext(body.dataset.elevaContext);
    const authenticated = body.dataset.elevaAuthenticated === 'true';

    if (authenticated || resolvedContext) {
      clearLegacyContext();
      return;
    }

    const legacyContext = getLegacyContext();
    if (!legacyContext) return;

    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { site_context: legacyContext.toLowerCase() } }),
    });

    if (!response.ok) throw new Error('Não foi possível migrar o contexto legado.');

    clearLegacyContext();
    window.location.reload();
  }

  document.addEventListener('DOMContentLoaded', () => {
    migrate().catch((error) => console.warn('[eleva-context-migration]', error));
  });
})();
